/**
 * @packageDocumentation
 * @module HackerAPI.Skill
 */
import { __extends } from "tslib";
import Base from "../base/base";
import HackerAPIFetch from "../hackerapi-fetch/hackerapi-fetch";
/**
 * Contains static methods for fetching skills from hackerapi
 * @class
 * @extends { HackerAPI.Base }
 */
var Skill = /** @class */ (function (_super) {
    __extends(Skill, _super);
    function Skill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetches the universal set of technical skills that one may hope to one day possess
     * @returns
     */
    Skill.fetchAll = function () {
        return HackerAPIFetch({
            path: "/v2/skills",
            method: "GET"
        });
    };
    return Skill;
}(Base));
export default Skill;
//# sourceMappingURL=skill.js.map